import React, { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack';
import { TextField, Button, Paper, Table, TableBody, TableCell, TableHead, TableRow, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress, Grid, InputAdornment, Tooltip, Switch } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { DeletePopUp, EmptyCollection, PageLoader, Pagination, RevisionHistory, SortableHeaderCell, STableLoader } from '../../shared_elements'
import StarOutlineIcon from '@material-ui/icons/StarOutline';
import StarIcon from '@material-ui/icons/Star';
import CloseIcon from '@material-ui/icons/Close';
import { DropzoneArea } from 'material-ui-dropzone';
import { globalGetService, globalPutService, globalPostService, globalExportService, globalDeleteService } from '../../../globalServices';
import { checkApiStatus, checkPermission, getLocalStorageInfo } from '../../utils_v2';
import { regexConstants } from '../../../constants/regEx';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import AddNewLessee from '../../../shared/components/AddNewLessee';
import ConfigData from '../master/components/ConfigData';
import { avationPlcInstance, gaTelesisInstance,hanwahaInstance} from '../../../shared/components';
import moment from 'moment';
import { downloadFileType } from '../../../utils';
import { fieldDateFormat } from '../../../constants';
import { Delete, SaveAlt } from '@material-ui/icons';
import ReadMoreInline from '../../../shared/components/ReadMoreInline';

const ChangeLesseeStatus = ({ editLessee, toggleModalFn, getResponseBack }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [lessee, setLessee] = useState(editLessee.data);
    const [error, setError] = useState({});
   
    const onFieldChange = (key, value) => {
        setLessee({
            ...lessee,
            favourite_lessee: {
                ...lessee.favourite_lessee,
                [key]: value
            }
        })
    }
    const onUpdateOrder = () => {
        let validationInputs = {
            sequence: lessee?.favourite_lessee?.sequence?.trim()?.length ? '' : 'Please enter the Sequence'
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            globalPutService(`console/user-favourite/lessee/${lessee.slug}/`, { flag: true, sequence: parseInt(lessee.favourite_lessee.sequence) })
                .then(response => {
                    if (checkApiStatus(response)) {
                        toggleModalFn(); getResponseBack();
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    }
                })
        } else {
            setError(validationInputs);
        }
    }
    return (
        <Dialog
            open={editLessee.modal}
            className='console-management-modal add-edit-role-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                Select the sequence for your favourite lessee
            </DialogTitle>
            <DialogContent dividers={true}>
                <div>
                    <Grid container>
                        <Grid item md={12}>
                            <TextField
                                required
                                id='sequence'
                                label='Sequence Number'
                                value={lessee?.favourite_lessee?.sequence || ''}
                                fullWidth
                                margin="normal"
                                error={error.sequence}
                                helperText={error?.sequence || ''}
                                onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange('sequence', e.target.value) : e.preventDefault() }}
                                onFocus={() => setError({ ...error, sequence: '' })}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button onClick={onUpdateOrder} disabled={isLoading} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const LesseeConfig = ({ }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [addEditLessee, setAddEditLessee] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [favLessees, setFavLessee] = useState({list: [], pagination: {}});
    const [editLessee, setEditLessee] = useState({ modal: false, data: null })
    const [search, setSearch] = useState('');
    const [importLessee,setImportLesse] =useState({modal:false,data:null})
    const [files, setFiles] = useState([]);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    useEffect(() => {
        getFavLessee({per_page: 50}, 'skeletonLoader');
    }, []);
    const getFavLessee = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        // keep the active sort on every refetch (pagination, edit, delete, import)
        globalGetService(`console/user-favourite/lessee/`, { ...(sortInfo.sort ? sortInfo : {}), ...query })
            .then(response => {
                if (checkApiStatus(response)) {
                    setFavLessee(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            })
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getFavLessee({ ...sortQuery, page: 1, per_page: favLessees?.pagination?.per_page || 50 }, 'pageLoader');
    }
    const onChangeStatus = (item) => {
        setLoading(true);
        globalPutService(`console/user-favourite/lessee/${item.slug}/`, { flag: false, sequence: item?.favourite_lessee?.sequence || null })
            .then(response => {
                if (checkApiStatus(response)) {
                    getFavLessee({ page: favLessees?.pagination?.page, per_page: favLessees?.pagination?.per_page || 50 }, 'pageLoader');
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
                setLoading(false);
            })
    }
    const onImport = () => {
        var formData = new FormData();
        formData.append('files', files[0]);
        setLoading(true)
        globalPostService(`console/lessor-lessees/import/`, formData)
            .then(response => {
                if (checkApiStatus(response)) {
                    getFavLessee({ page: favLessees?.pagination?.page, per_page: favLessees?.pagination?.per_page || 50 }, 'pageLoader');
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                    setImportLesse(false)
                } else {
                    setImportLesse(false)
                }
                setLoading(false)
            })
    }
    const exportSample = () => {
        setLoading(true)
        globalExportService(`console/lessor-lessees/export/?is_sample_export=true`)
        .then(response =>{
            setLoading(false)
            downloadFileType(response, `Import_Lessee`, 'xlsx')
        })
    };
    const onToggle = (flag, item) => {
        setLoading(true);
        globalPutService(`console/lessor-lessees/${item?.slug}/`,{is_active:flag})
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    getFavLessee({ page: favLessees?.pagination?.page, per_page: favLessees?.pagination?.per_page || 50 }, 'pageLoader');
                } 
                // else {
                //     enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                // }
            })
    }
    const getLesseeDetails = (item) => {
        globalGetService(`console/lessor-lessees/${item?.slug}/`)
            .then(response => {
                setAddEditLessee({ modal: true, mode: 'edit', data: response.data.data })
            })
    }
    const onExportLessee = () => {
        setLoading(true);
        globalExportService(`console/lessor-lessees/export/`)
            .then(response => {
                downloadFileType(response, `Lessee_List ${moment().format(fieldDateFormat)}`, 'xlsx')
                setLoading(false)
            });
    }
    return (
        <section className='config-container' style={{ margin: '24px 0 0 75px', }}>
            <Paper className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content">
                    {/* <Paper> */}
                        {skeletonLoader ? <STableLoader count={4} size={9} /> :
                            <>
                                <div className="console-forms-fields console-paper" style={{ padding: '10px', borderRadius: "5px", marginBottom: "10px" }}>
                                    <Alert severity="info">Please mark your favourite lessee's by selecting the star icon and enter the order in which you want to see the lessee</Alert>
                                    <Grid container>
                                        <Grid item md={6}>
                                            <TextField
                                                id='lessee'
                                                value={search}
                                                fullWidth
                                                placeholder='Search by Lessee Name'
                                                margin="normal"
                                                onChange={(e) => setSearch(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                variant='outlined'
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">
                                                        <CloseIcon onClick={() => setSearch('')} style={{ cursor: 'pointer' }} fontSize='small' />
                                                    </InputAdornment>,
                                                }}
                                            />
                                        </Grid>
                                    <Grid item md={6} style={{ textAlign: "right", }}>
                                        <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                            {
                                                checkPermission('config_data', 'lessee_config', 'R') ?
                                                    <li className='list-inline-item'>
                                                        <Button style={{ marginTop: "23px", marginLeft: "10px" }} disabled={!favLessees?.list?.length} onClick={() => onExportLessee()} color='primary' size='small' variant='outlined' startIcon={<SaveAlt style={{ fontSize: '1.2rem' }} />}> Export </Button>
                                                    </li> : null}
                                            {
                                                checkPermission('config_data', 'lessee_config', 'IMP') ?
                                                    <li className='list-inline-item'>
                                                        <Button style={{ marginTop: "23px", marginLeft: "10px" }} onClick={() => setImportLesse({ modal: true, data: null })} color='primary' size='small' variant='outlined'>
                                                            <AddIcon style={{ fontSize: '1.15rem' }} />Import
                                                        </Button> </li> : null}
                                            {
                                                checkPermission('config_data', 'lessee_config', 'C') ?
                                                    <li className='list-inline-item'>
                                                        <Button style={{ marginTop: "23px", marginLeft: "10px" }} onClick={() => setAddEditLessee({ modal: true })} color='primary' size='small' variant='contained'><AddIcon style={{ fontSize: '1.15rem' }} />Add New Lessee</Button> </li> : null}
                                            <li className='list-inline-item' style={{ cursor: 'pointer', marginTop: '23px', marginLeft: '10px' }}>
                                                <RevisionHistory isExp={false} buttonType={true} url={`audit/console/amlesseeandoperatorsv2/`} queryParams={{ action: '0,1,2' }} />
                                            </li>
                                        </ul>
                                    </Grid>
                                    </Grid>
                                </div>
                                {(() => {
                                    const lesseeList = favLessees?.list || [];
                                    let filterList = search.trim().length ? lesseeList.filter((item) => item.name.toLowerCase().includes(search.toLowerCase())) : lesseeList;
                                    return (
                                        <Paper square >
                                         <div style={{ height: `${window.innerHeight - 300}px`, overflow: 'auto' }}>
                                            <Table className='mui-table-format' stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, width:'100px', minWidth: '110px', boxSizing: 'border-box' }}>Action(s)</TableCell>
                                                        <TableCell style={{ position: 'sticky', left: 110, backgroundColor: '#B5BEDB', zIndex: 10, }}>Status</TableCell>
                                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="name">Lessee Name</SortableHeaderCell>
                                                        
                                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="country_of_incorporation">Country Of Incorporation</SortableHeaderCell>
                                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="country_code">Country Code</SortableHeaderCell>
                                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="contact_email">Contact(Email)</SortableHeaderCell>
                                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="contact_phone_number">Contact(Phone No.)</SortableHeaderCell>
                                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="contact_fax_number">Contact Fax</SortableHeaderCell>
                                                        <TableCell>Lessee Logo</TableCell>
                                                        {hanwahaInstance ? <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="lessee">Lessee</SortableHeaderCell>: null}
                                                        <TableCell>Sequence</TableCell>
                                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="atten_to">Attention To</SortableHeaderCell>
                                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="vat_registration_number">VAT Registration Number</SortableHeaderCell>
                                                        <TableCell>Contact Adress</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {filterList?.map((item, index) =>
                                                        <TableRow key={index}>
                                                            <TableCell style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, }}>
                                                                <ul className='list-inline' style={{display:'flex', alignItems:'center'}}>
                                                                    <li className='list-inline-item' style={{ cursor: 'pointer' }} onClick={(e) => e.stopPropagation()}>
                                                                        <RevisionHistory isExp={false} buttonType={true} url={`audit/console/amlesseeandoperatorsv2/`} queryParams={{ action: '0,1,2', object_id: item?.id }} />
                                                                    </li>
                                                                    {checkPermission('config_data', 'lessee_config', 'U') ?
                                                                        <li className='list-inline-item'>
                                                                            <Tooltip title="Edit" arrow placement='top'>
                                                                                <EditIcon style={{ cursor: 'pointer' }} onClick={() => getLesseeDetails(item)} color='primary' fontSize='small' />
                                                                            </Tooltip>
                                                                        </li>
                                                                        : null}
                                                                        <li className='list-inline-item' >
                                                                            {item.favourite_lessee.flag ?
                                                                    <StarIcon style={checkPermission('config_data', 'lessee_config', 'STS') ? { cursor: 'pointer' } : {}} onClick={(e) => checkPermission('config_data', 'lessee_config', 'STS') ? onChangeStatus(item) : e.preventDefault()} color='primary' fontSize='small' /> :
                                                                    <StarOutlineIcon style={checkPermission('config_data', 'lessee_config', 'STS') ? { cursor: 'pointer' } : {}} onClick={(e) => checkPermission('config_data', 'lessee_config', 'STS') ? setEditLessee({ modal: true, data: item }) : e.preventDefault()} color='primary' fontSize='small' />
                                                                }
                                                                        </li>
                                                                </ul>
                                                            </TableCell>
                                                            <TableCell style={{ position: 'sticky', left: 110, backgroundColor: 'inherit', zIndex: 1, }}>
                                                                 <Tooltip title={item?.is_active === false ? 'Inactive' : 'Active'} arrow placement='top'>
                                                                                <span>
                                                                                    <Switch
                                                                                        disabled={getLocalStorageInfo()?.user?.group_profile_order?.id === 0?false :true}
                                                                                        size="small"
                                                                                        color="primary"
                                                                                        checked={item?.is_active !== false}
                                                                                        onChange={(e) => onToggle(e.target.checked, item)}
                                                                                    />
                                                                                </span>
                                                                            </Tooltip>
                                                            </TableCell>
                                                            <TableCell><div style={{minWidth:'200px'}}>{item?.name || '--'}</div></TableCell>
                                                            <TableCell><div style={{minWidth:'180px'}}>{item?.country_of_incorporation || '--'}</div></TableCell>
                                                            <TableCell><div style={{minWidth:'160px'}}>{item?.country_code || '--'}</div></TableCell>
                                                            <TableCell><div style={{minWidth:'180px'}}>{item?.contact_email || '--'}</div></TableCell>
                                                            <TableCell><div style={{minWidth:'160px'}}>{item?.contact_phone_number || '--'}</div></TableCell>
                                                            <TableCell><div style={{minWidth:'160px'}}>{item?.contact_fax_number || '--'}</div></TableCell>
                                                            <TableCell><div style={{minWidth:'120px'}}>{item.logo ? <img style={{ height: '28px' }} src={item.logo} /> : '--'}</div></TableCell>
                                                            {hanwahaInstance ? <TableCell style={{minWidth:'160px'}}>{item?.lessee || '--'}</TableCell>: null}
                                                            <TableCell><div style={{minWidth:'100px'}}>{item?.favourite_lessee?.sequence || '--'}</div></TableCell>
                                                            <TableCell><div style={{minWidth:'150px'}}>{item?.atten_to || '--'}</div> </TableCell>
                                                            <TableCell><div style={{minWidth:'200px'}}>{item?.vat_registration_number || '--'}</div></TableCell>
                                                            <TableCell style={{minWidth:'300px'}}><ReadMoreInline text={`${item?.contact_address||'--'}`} /></TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                                 {!filterList.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                         </div>
                                        </Paper>
                                    )
                                })()}
                                <Paper square>
                                    <Pagination
                                        pagination={favLessees?.pagination}
                                        onChangePage={(event, newPage) => getFavLessee({ page: newPage + 1, per_page: favLessees?.pagination?.per_page }, 'pageLoader')}
                                        onChangeRowsPerPage={(event) => getFavLessee({ page: 1, per_page: event.target.value }, 'pageLoader')}
                                    />
                                </Paper>
                            </>
                        }
                        {editLessee.modal ?
                            <ChangeLesseeStatus
                                toggleModalFn={() => setEditLessee({ modal: false, data: null })}
                                getResponseBack={() => getFavLessee({ page: favLessees?.pagination?.page, per_page: favLessees?.pagination?.per_page || 50 }, 'pageLoader')}
                                editLessee={editLessee}
                            /> : null
                        }
                        {
                            addEditLessee?.modal ?
                                <AddNewLessee
                                    addEditLessee={addEditLessee}
                                    getResponseBack={() => getFavLessee({ page: favLessees?.pagination?.page, per_page: favLessees?.pagination?.per_page || 50 }, 'pageLoader')}
                                    toggleModalFn={() => setAddEditLessee({ modal: false, data: {} })}
                                />
                                : null
                        }
                        {
                            importLessee?.modal ?
                                <Dialog
                                    open={true}
                                    maxWidth={'md'}
                                >
                                    <DialogTitle id="scroll-dialog-title">
                                        Import Lessee
                                    </DialogTitle>
                                    <DialogContent dividers={true}>
                                        <div style={{ width: '380px' }}>
                                            <p>Please refer the sample sheet, <a style={{ color: '#3f51b5' }} onClick={exportSample}>Download</a></p>
                                            <div>
                                                <DropzoneArea
                                                    filesLimit={1}
                                                    maxFileSize={104857600}
                                                    acceptedFiles={['.xls', '.xlsx']}
                                                    showPreviewsInDropzone={false}
                                                    useChipsForPreview={true}
                                                    showPreviews={true}
                                                    dropzoneText={<p>Drag & Drop file Or Click Here </p>}
                                                    dropzoneClass="drag-drop-cnt"
                                                    maxWidth="sm"
                                                    showAlerts={['info', 'error']}
                                                    alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                                    clearOnUnmount={true}
                                                    onChange={(files) => setFiles(files)}
                                                />
                                            </div>
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button disabled={isLoading} color="primary" size='small' onClick={() => { setImportLesse(false) }}>Cancel</Button>
                                        <Button size='small' disabled={isLoading || !files.length} color="primary" variant="contained" onClick={onImport}>
                                            {isLoading ? <CircularProgress color="#ffffff" size={24} /> : 'Save'}
                                        </Button>
                                    </DialogActions>
                                </Dialog> : null
                        }
                        {isLoading ? <PageLoader /> : null}
                    {/* </Paper> */}
                </div>
            </Paper>
        </section>
    )
}
export default LesseeConfig;